import { actions as loadingActions } from "../../components/loading/index";
import { message, notification, Modal, Card,Result, Button } from "antd";
import {history} from '../../extendedBrowserRouter'
const { confirm } = Modal;

export const fetchProblems = (formVal, history, categary) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const batch = firestore.batch();
  };
};

//https://us-central1-vedicplatform.cloudfunctions.net/codechefSolvedProblems/api/solved_problems/v1.0/devihhs
//https://us-central1-vedicplatform.cloudfunctions.net/geeksforgeeksSolvedProblems/api/solved_problems/v1.0/DevBhushan
//https://us-central1-vedicplatform.cloudfunctions.net/hackerearthSolvedProblems/api/user_profile/v1.0/dev12321
//https://us-central1-vedicplatform.cloudfunctions.net/hackerankSolvedProblems/api/problem_submissions/v1.0/devbhushan12321

/* eslint-disable import/first */

export const loadUserProfileData = uid => {
  
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const state = getState();
   
    const firestore = getFirestore();
    dispatch(loadingActions.showLoading());
    firestore
    .doc(`students/${uid}`)
    .get()
    .then(doc => {
      
      if(doc.exists){
        if(state.firebase.auth.uid ===doc.data().UID &&
        doc.data().profileCurrentStep < 11 ){
         dispatch(loadingActions.hideLoading());
          message.warning("Your profile is incomplete. Complete it to proceed");
          history.push("/home/overview");
        }
        else{
          dispatch({
            type: "LOAD__USER_PROFILE_DATA",
            payload:  { uid, valid: true, ...doc.data() },
            skeltonLoading:false
          });
          dispatch(loadingActions.hideLoading());
        }
      }
      else{
        dispatch(loadingActions.hideLoading());
        notification.error({
          message: 'User profile not found with UID - ' + uid,
          description:
            'Redirected to overall Dashboard'
        });
        history.push('/home/campusDashboard/ADMIN')
      }

    }).catch(function(error) {
      
      notification.error({
        message: 'Something went wrong',
        duration:0,
        description:
          'Please refresh to try again. Error '+error
      });
      dispatch(loadingActions.hideLoading());
    });
  }
}

export const loadOtherUserData = (uid, history) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const state = getState();
    const firestore = getFirestore();
    dispatch(loadingActions.showLoading());
    firestore
      .doc(`students/${uid}`)
      .get()
      .then(doc => {
       

        if (!doc.exists) {
          message.error("Invalid Profile ID");
          history.push("/home/overview");
        } else if (
          doc.data().UID === state.firebase.auth.uid &&
          doc.data().profileCurrentStep < 9
        ) {
          message.warning("Your profile is incomplete");
          history.push("/home/overview");
        } else if (doc.data().profileCurrentStep < 1) {
          message.error("The User has not completed his profile");
          history.push("/home/overview");
        }
        dispatch({
          type: "LOAD_OTHER_USER_DATA",
          payload: doc.exists
            ? { uid, valid: true, ...doc.data() }
            : { uid, valid: false }
        });
        dispatch(loadingActions.hideLoading());
      })
      .catch(function(error) {
        
        dispatch(loadingActions.hideLoading());
      });
  };
};

export const modelFromStep = (visible, loading, step, itemIndex = null) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    // 
    dispatch({
      type: "HIDE_MODEL_FROM_STEP",
      payload: {
        visible,
        loading,
        step,
        itemIndex
      }
    });
  };
};

export const deleteItem = (val, category, arrayField) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());

    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    let data = {
      [category]: firestore.FieldValue.arrayRemove(val),
      [category + "Array"]: firestore.FieldValue.arrayRemove(val[arrayField])
    };
    // 

    firestore
      .doc(`students/${uid}`)
      .set(data, { merge: true })
      .then(function() {
        dispatch(loadingActions.hideLoading());
      })
      .catch(function(error) {
        // 
        message.error(
          "Something went wrong. Please refresh the page and try again" + error
        );
      });
  };
};

export const stepWithSkillsSubmit = (
  formVal,
  history,
  categary,
  step,
  arrayField,
  itemIndex = null
) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    //dispatch(loadingActions.showLoading());
    dispatch({
      type: "HIDE_MODEL_FROM_STEP",
      payload: {
        visible: true,
        loading: true,
        step: step,
        itemIndex: itemIndex
      }
    });
    // 
    // 
    if (typeof formVal.workshopDate !== "undefined") {
      // 
      formVal.workshopDate = formVal.workshopDate.toString();
    }
    if (typeof formVal.internshipDate !== "undefined") {
      formVal.internshipDate = formVal.internshipDate.toString();
    }
    if (typeof formVal.publicationDate !== "undefined") {
      formVal.publicationDate = formVal.publicationDate.toString();
    }
    if (typeof formVal.certificationDate !== "undefined") {
      formVal.certificationDate = formVal.certificationDate.toString();
    }
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    // 
    if (itemIndex !== null) {
      const itemData = getState().firebase.profile[categary];
      itemData[itemIndex] = formVal;
      // 
      firestore
        .doc(`students/${uid}`)
        .set({ [categary]: itemData }, { merge: true })
        .then(function() {
          dispatch({
            type: "HIDE_MODEL_FROM_STEP",
            payload: {
              visible: false,
              loading: false,
              step: step,
              itemIndex: itemIndex
            }
          });
        })
        .catch(function(error) {
          // 
          message.error(
            "Something went wrong. Please refresh the page and try again" +
              error
          );
        });
    } else {
      let data = {
        [categary]: firestore.FieldValue.arrayUnion(formVal),
        [categary + "Array"]: firestore.FieldValue.arrayUnion(
          formVal[arrayField]
        )
      };
      firestore
        .doc(`students/${uid}`)
        .set(data, { merge: true })
        .then(function() {
          dispatch({
            type: "HIDE_MODEL_FROM_STEP",
            payload: {
              visible: false,
              loading: false,
              step: step,
              itemIndex: itemIndex
            }
          });
        })
        .catch(function(error) {
          // 
          message.error(
            "Something went wrong. Please refresh the page and try again" +
              error
          );
        });
    }
  };
};

export const fetchSolvedProblems = (websiteName, UID) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    // dispatch(loadingActions.showLoading());
    // 
    const firestore = getFirestore();
    firestore
    .doc(`cpProblems/${websiteName}/usersCP/${UID}`)
    .get()
    .then(doc => {
      if(doc.exists){
        dispatch({
          type: "LOAD_SOLVED_PROBLEM",
          payload: {[websiteName]: {uid: UID, data:doc.data(),problemsList:doc.data().problemsList ? Object.keys(doc.data().problemsList).map(key => (doc.data().problemsList)[key]) : [], skeltonLoading:false }
          }
          });
      }
      else{
        dispatch({
          type: "LOAD_SOLVED_PROBLEM",
          payload: {[websiteName]: { uid: UID, data:[],problemsList:[],skeltonLoading:false  } }
        });
      }
    })
  };
};
